import styled from 'styled-components'
import InvoiceTable from './InvoiceTable'
import useInvoices from './useInvoices'
import { useState } from 'react'
import InvoiceDialog from './InvoiceDialog'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import FloatingActionBtn from 'ui/components/FloatingActionBtn'
import { useIntl } from 'react-intl'
import config from 'config'
import InvoiceView from './InvoiceView/InvoiceView'
import useCustomers from './useCustomers'
import { useSelectedFinanceCompany } from '../../hooks/useSelectedFinanceCompany'
export const Container = styled.div`
	width: 100%;
`

const HASH_INVOICES = config.routeHashes.invoicingInvoices

const InvoicesView = () => {
	const intl = useIntl()
	const [addDialogVisible, setDialogVisible] = useState<boolean>(false)
	const [creditDialogVisible, setCreditDialogVisible] = useState<boolean>(false)
	const dispatch = useDispatch()
	const { company } = useSelectedFinanceCompany()
	const { invoices, refresh } = useInvoices({
		companyUUID: company?.uuid,
		databaseSource: company?.integrations?.viiluTalous?.databaseSource,
	})
	const { customers } = useCustomers({
		companyUUID: company?.uuid,
		databaseSource: company?.integrations?.viiluTalous?.databaseSource,
	})

	const mappedInvoices = invoices.map((invoice) => {
		const customer = customers.find((c) => c?.id === invoice?.customerId)
		let customerName = ''
		if (customer) {
			if (customer.company) {
				customerName = customer.company
			} else if (customer.surname || customer.firstName) {
				customerName = [customer.surname, customer.firstName]
					.filter(Boolean)
					.join(' ')
			}
		}
		return { ...invoice, customerName }
	})

	const uuid = useSelector((state: any) => state.router?.location?.query?.uuid)

	const showAddDialog = () => {
		setDialogVisible(true)
	}

	const showCreditDialog = () => {
		setCreditDialogVisible(true)
	}
	const hideCreditDialog = () => {
		setCreditDialogVisible(false)
	}

	const hideDialog = () => {
		if (uuid) {
			dispatch(push(window.location.pathname + HASH_INVOICES))
		}
		setDialogVisible(false)
	}

	const renderInvoiceFAB = () => {
		return (
			<FloatingActionBtn
				iconName={'add'}
				text={intl.formatMessage({
					defaultMessage: 'UUSI LASKU',
					description: 'Add invoice',
				})}
				action={showAddDialog}
			/>
		)
	}
	const renderCreditFAB = () => {
		return (
			<FloatingActionBtn
				iconName={'add'}
				text={intl.formatMessage({
					defaultMessage: 'UUSI HYVITYSLASKU',
					description: 'Add credit invoice',
				})}
				action={showCreditDialog}
				second
			/>
		)
	}

	return (
		<Container>
			<InvoiceTable invoices={mappedInvoices} />
			{addDialogVisible && (
				<InvoiceDialog refresh={refresh} onHide={hideDialog} />
			)}
			{typeof uuid === 'string' && (
				<InvoiceView id={uuid} refresh={refresh} onHide={hideDialog} />
			)}

			{creditDialogVisible && (
				<InvoiceDialog refresh={refresh} onHide={hideCreditDialog} credit />
			)}

			{renderInvoiceFAB()}
			{renderCreditFAB()}
		</Container>
	)
}

export default InvoicesView
